"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _CccisdFieldWrapper = _interopRequireDefault(require("../CccisdFieldWrapper"));
var _cccisdColorPicker = _interopRequireDefault(require("cccisd-color-picker"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = function _default(props) {
  var field = props.field,
    form = props.form;
  var onChange = function onChange(value) {
    form.setFieldValue(field.name, value);
    form.setFieldTouched(field.name);
  };
  return /*#__PURE__*/_react["default"].createElement(_CccisdFieldWrapper["default"], props, /*#__PURE__*/_react["default"].createElement(_cccisdColorPicker["default"], {
    value: field.value,
    onChange: onChange
  }));
};